import React from 'react';
import { buttonRootStyle } from '@teetsh/app/src/components/Buttons/Button';
import { ButtonContent } from './ButtonContent';
import { BaseButtonProps } from './BaseButtonProps';
import clsx from 'clsx';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  'aria-label'?: string;
  id?: string;
  href: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
}

export default function ButtonExternal(props: Props & BaseButtonProps) {
  const {
    href,
    target = '_blank',
    className,
    active,
    alignText,
    disabled,
    loading,
    extralarge,
    fill,
    intent,
    large,
    outlined,
    small,
    minimal,
    iconSize,
    ...rest
  } = props;
  return (
    <a
      css={[
        buttonRootStyle({
          active,
          alignText,
          disabled,
          extralarge,
          fill,
          hasChildren: !!props.children,
          intent,
          large,
          loading,
          minimal,
          outlined,
          small,
        }),
      ]}
      target={target}
      href={href}
      rel="noopener noreferrer"
      className={clsx('tsh-button', className)}
      {...rest}
    >
      <ButtonContent {...props} />
    </a>
  );
}
